module.exports = __webpack_public_path__ + "static/img/gpt4.fce3eb9e.jpg";